/**
 * Get file type from file name
 */
export const getFileType = (fileName: string): 'image' | 'pdf' | 'video' | 'other' => {
  const extension = fileName.split('.').pop()?.toLowerCase();

  if (!extension) return 'other';

  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp', 'bmp', 'ico', 'tiff', 'tif'];
  const videoExtensions = ['mp4', 'webm', 'ogg', 'mov', 'avi', 'wmv', 'flv', 'mkv', 'm4v', '3gp'];

  if (imageExtensions.includes(extension)) {
    return 'image';
  }

  if (extension === 'pdf') {
    return 'pdf';
  }

  if (videoExtensions.includes(extension)) {
    return 'video';
  }

  return 'other';
};
